import { AxiosInstance } from 'axios'
import { SeoBlock, SeoMeta } from '@/shared/api/strapi/requests/types'

export type GetSpecialistSeoArgs = {
  locale: string
  slug: string
}

export const getSpecialistSeo = async (
  client: AxiosInstance,
  { locale, slug }: GetSpecialistSeoArgs,
): Promise<SeoBlock | undefined> => {
  const path = `/specialists`
  const params = {
    locale: locale,
    sort: { createdAt: 'desc' },
    populate: {
      seo: {
        populate: '*',
      },
    },
    filters: {
      slug: {
        $eq: slug,
      },
    },
  }
  const resp = (
    await client.get<{
      data: Array<{ attributes?: { seo: SeoMeta } }>
    }>(path, { params })
  ).data
  return resp.data[0].attributes?.seo[0]
}
